module.exports = __webpack_public_path__ + "img/3.08853034.png";